export default __webpack_public_path__ + "static/pc-carousel-03-93576b71b2e9ef7ccea8f28cccb9064c.jpg";